import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Notifications from 'vue-notification'
import axios from 'axios'
import Utils from '@/utils.js'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import {
  LOGOUT_ACTION
} from '@/store-constants.js';

global.jQuery = require('jquery');

Vue.config.productionTip = false

// fontawesome free
import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  faCoffee,
  faMinusSquare,
  faPlusSquare,
  faTrash,
  faComment,
  faCheckDouble,
  faIdCard,
  faChartBar,
  faProcedures,
  faIdBadge,
  faListOl,
  faSignOutAlt,
  faArrowCircleRight,
  faShare
} from '@fortawesome/free-solid-svg-icons'
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'
library.add(faCoffee, faMinusSquare, faPlusSquare, faTrash, faComment, faCheckDouble, faIdCard, faChartBar, faProcedures, faIdBadge, faListOl, faSignOutAlt, faArrowCircleRight, faShare)
Vue.component('font-awesome-icon', FontAwesomeIcon)

import io from 'socket.io-client';

import {
  REFRSH_OVERVIEW
} from '@/web-socket-constants.js';

import {
  EventBus
} from '@/global-event-bus.js';

import {
  REFRESH_OVERVIEW
} from '@/event-constants.js';
import { REFRESH_PENDING_TEST_COUNT } from './event-constants'


Vue.use(Notifications);
Vue.use(Loading, {
  color: '#2f477a',
  loader: 'dots',
  width: 70,
  height: 70,
  opacity: 0.5,
  backgroundColor: '#000000'
});



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');


// this is needed for CORS and cookie based authentication
// axios.defaults.withCredentials = true;

// axios interceptor to inject jwt token to all the requests
axios.interceptors.request.use(config => {
  var token = store.getters.token;

  if (token == null) {
    return config;
  }

  config.headers.Authorization = 'Bearer ' + token;
  return config;
}, error => {
  return Promise.reject(error);
});


axios.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response.status == 401) {
    // show login page
    store.dispatch(LOGOUT_ACTION);
  }
  return Promise.reject(error);
});

// web socket initialization and listening
let backendUrl = Utils.getBackendURL();
if (backendUrl.substr(backendUrl.length - 4, 4) == '/api') {
  backendUrl = backendUrl.substr(0, backendUrl.length - 4)
}

var socket = io.connect(backendUrl);
socket.on('connect', function () {
  console.log("Server connected");
});


socket.on(REFRSH_OVERVIEW, function (msg) {
  EventBus.$emit(REFRESH_OVERVIEW);
});

socket.on(REFRESH_PENDING_TEST_COUNT, function (msg) {
  EventBus.$emit(REFRESH_PENDING_TEST_COUNT);
});

